import { useLingui } from '@lingui/react/macro';
import { TriangleAlert } from 'lucide-react';
import React from 'react';
import { useFontStatus } from 'shared/fonts/use-font-status';
import { theme } from 'styles/theme/theme';
import UDTippy from 'ud-ui/components/tippy';

interface FontLoadWarningProps {
  /** Значение объекта: голое имя или CSS-стек. */
  fontFamily: string | undefined;
  fontWeight?: string | number;
}

/**
 * Предупреждение у выбора шрифта: шрифт не загрузился, и на канве запасной — дизайнер иначе видит
 * не то, что увидит зритель. Пока шрифт грузится, ничего не показывается. Цвет — тёмный оттенок
 * шкалы `DarkYellow`: `warning` на светлой панели инспектора не читается (`conventions.md`, «Colors»).
 */
function FontLoadWarning({ fontFamily, fontWeight }: FontLoadWarningProps) {
  const { t } = useLingui();
  const status = useFontStatus(fontFamily, fontWeight);
  if (status !== 'failed') return null;

  const message = t`Шрифт не загрузился — на канве запасной`;
  return (
    <UDTippy content={message} size="xs" placement="top">
      <span role="img" aria-label={message} style={{ display: 'inline-flex', color: theme.colors.DarkYellow800, flexShrink: 0 }}>
        <TriangleAlert size={16} aria-hidden />
      </span>
    </UDTippy>
  );
}

export default FontLoadWarning;
